export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "Okulus";

export const APP_LOGO = "/okulus-logo.png";

// Return local login page URL
export const getLoginUrl = () => {
  return "/login";
};
